export const AGENTS = {
    diagnostic: {
        type: 'diagnostic',
        name: 'Diagnostic Agent',
        url: '/ai/diagnostic-agent',
    },
    builder: {
        type: 'builder',
        name: 'Builder Agent',
        url: '/ai/builder-agent',
    },
}
